import { useEffect, useState } from 'react';
import Title from './components/Title/Title';
import FinalDate from './components/FinalDate/FinalDate';
import Countdown from './components/Countdown/Countdown';
import CountdownDetails from './components/CountdownDetails/CountdownDetails';
import { finalDate } from './constants';

function App() {
  const [diff, setDiff] = useState(null);

  useEffect(() => {
    const id = setInterval(() => {
      const currDate = new Date();
      setDiff(finalDate - currDate);
    }, 1000);
    return () => clearInterval(id); //stop timer on unmount
  }, []);

  return (
    <div className="full-screen-container">
      {/*<div className="app-container">*/}
      <Title />
      <div className="app-content">
        {/*<img src={weddingRings} className="wedding-rings" alt="logo" />*/}
        <FinalDate finalDate={finalDate} />
        <Countdown diff={diff} />
        <CountdownDetails diff={diff} />
        {/*</div>*/}
      </div>
    </div>
  );
}

export default App;
